export default __webpack_public_path__ + "static/media/notion.0d69dfc3.svg";